module.exports = __webpack_public_path__ + "static/media/smoker.4d9b623f.png";